import React from "react";
import { Truck } from "lucide-react";

export const FREE_SHIPPING_THRESHOLD = 85;

/**
 * Progress bar showing how close the cart is to unlocking complimentary UK
 * shipping. Renders nothing when the cart is empty (handled by parent).
 */
export const FreeShippingBar = ({ total }) => {
  const remaining = Math.max(0, FREE_SHIPPING_THRESHOLD - total);
  const pct = Math.min(100, (total / FREE_SHIPPING_THRESHOLD) * 100);
  const unlocked = total >= FREE_SHIPPING_THRESHOLD;

  return (
    <div className="mb-5" data-testid="free-shipping-bar">
      <div className="flex items-center gap-2 mb-2">
        <Truck className="w-3.5 h-3.5 text-[#1a1814]" strokeWidth={1.25} />
        <div className="micro-label text-[#1a1814] text-[10px]">
          {unlocked
            ? "Complimentary UK shipping unlocked"
            : `£${remaining.toFixed(2)} to complimentary UK shipping`}
        </div>
      </div>
      <div className="h-[2px] w-full bg-[#1a1814]/15 overflow-hidden">
        <div
          className="h-full bg-[#1a1814] transition-all duration-500"
          style={{ width: `${pct}%` }}
          data-testid="free-shipping-progress"
        />
      </div>
    </div>
  );
};
